import { render, staticRenderFns } from "./TypeDescriptions.vue?vue&type=template&id=64b3eba1&scoped=true"
import script from "./TypeDescriptions.vue?vue&type=script&lang=ts"
export * from "./TypeDescriptions.vue?vue&type=script&lang=ts"
import style0 from "./TypeDescriptions.vue?vue&type=style&index=0&id=64b3eba1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b3eba1",
  null
  
)

export default component.exports